<template>
    <Modal @modal:dismiss="$emit('dismiss')">
        <h3 slot="header">{{ value.id ? 'Modifier' : 'Créer' }} un groupe d'objets</h3>
        <div slot="body">
            <div class="form-control">
                <label>
                    Nom du groupe d'objets <b>(obligatoire)</b>
                    <InputUniqChecker
                        class="stretch"
                        placeholder="Renseignez un nom de groupe"
                        required
                        v-model="value.name"
                        :err-msg="`Un groupe nommé ${value.name} existe déjà`"
                        url="/api/check/objectGroup/name"
                    />
                </label>
            </div>
            <!-- Suppression de keys dans les props : (props: ['value', 'themes', 'keys']) + suppression import "import CustomSelectTag from './../SelectTag';' + component "CustomSelectTag"
			<div class="form-control">
                <label>
                    Requête simple (Attributs présents)
                    <CustomSelectTag
                        class="stretch"
                        placeholder="Sélectionnez les attributs"
                        :options="keys"
                        :multiple="true"
                        v-model="value.keys"
                    />
                </label>
            </div>
			-->
            <div class="form-control">
                <label> <CustomInputTagJSON class="stretch" v-model="value.query_json" /> </label>
            </div>
            <div class="form-control">
                <label>
                    Thème parent <b>(obligatoire)</b>
                    <CustomSelect
                        class="stretch"
                        placeholder="Sélectionnez le thème parent"
                        required
                        :options="themes"
                        :multiple="false"
                        v-model="value.theme"
                    />
                </label>
            </div>
        </div>
        <div slot="footer">
            <div class="form-control form-inline">
                <CustomButton class="stretch" @click="$emit('dismiss')">Annuler</CustomButton>
                <CustomButton class="default stretch" @click="$emit('close')">
                    Enregistrer
                </CustomButton>
            </div>
        </div>
    </Modal>
</template>

<script>
import Modal from './../Modal';
import CustomButton from './../Button';
import CustomSelect from './../Select';
import CustomInputTagJSON from '@/components/InputTagJSON';
import InputUniqChecker from './../InputUniqChecker';

export default {
    props: ['value', 'themes'],
    components: {
        Modal,
        InputUniqChecker,
        CustomInputTagJSON,
        CustomButton,
        CustomSelect,
    },
};
</script>

<style lang="scss"></style>
